import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  AddDocumentLinkDetail,
  DeleteDocumentLinkDetail,
  fetchDocumentLinkAll,
  fetchDocumentLinkDetail,
  UpdateDocumentLinkDetail,
} from "../../Redux/WhatsappSlice/DocumentLinkSetup";
import { toast } from "react-toastify";
import WpDynamicTable from "../../Components/WhatsappTable/WpDynamicTable";
import Loader from "../../Components/Loader/Loader";

const DocumentLinkDetail = () => {
  const dispatch = useDispatch();

  const { DocumentLinks, DocumentLinkDetails } = useSelector(
    (state) => state.DocumentLinkSetup
  );

  const [formData, setFormData] = useState({
    ClientName: "",
    DocHeaderName: "",
    DocHeaderValue: "",
  });

  const [editId, setEditId] = useState(null);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    dispatch(fetchDocumentLinkAll());
    dispatch(fetchDocumentLinkDetail());
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = (formData) => {
    const errors = {};

    if (!formData.ClientName || formData.ClientName.trim() === "") {
      errors.ClientName = "Client Name is required";
    }

    if (!formData.DocHeaderName || formData.DocHeaderName.trim() === "") {
      errors.DocHeaderName = "Doc Header Name is required";
    }

    if (!formData.DocHeaderValue || formData.DocHeaderValue.trim() === "") {
      errors.DocHeaderValue = "Doc Header Value is required";
    }
    return errors;
  };

  const handleDelete = async (row) => {
    const isConfirmed = window.confirm(
      `Are you sure you want to delete this item?`
    );
    if (!isConfirmed) return;

    try {
      await dispatch(DeleteDocumentLinkDetail({ id: row.MainId })).unwrap();
      toast.success("Data deleted successfully!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
      });
      dispatch(fetchDocumentLinkDetail()); // refresh list
    } catch (error) {
      toast.error(`Failed to delete Data: ${error}`, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
      });
    }
  };

  const handleEdit = (row) => {
    setEditId(row.MainId);
    setFormData({
      // ClientName: row.ClientName?._id || "",
      ClientName: row.ClientNameId || "",
      DocHeaderName: row.DocHeaderName,
      DocHeaderValue: row.DocHeaderValue,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    if (Object.keys(validationErrors).length === 0) {
      try {
        if (editId) {
          await dispatch(
            UpdateDocumentLinkDetail({ id: editId, formData })
          ).unwrap();
          toast.success("Data updated successfully!", {
            position: "top-right",
            autoClose: 1000,
          });
        } else {
          await dispatch(AddDocumentLinkDetail({ values: formData })).unwrap();
          toast.success("Data added successfully!!", {
            position: "top-right",
            autoClose: 1000,
          });
        }

        // Reset form
        setFormData({
          ClientName: "",
          DocHeaderName: "",
          DocHeaderValue: "",
        });
        dispatch(fetchDocumentLinkDetail());
      } catch (error) {
        toast.error(
          `Failed to ${
            editId ? "update" : "add"
          }  Whatsapp Document Link Detail Data: ${
            error.message || "Unknown error"
          }`,
          {
            position: "top-right",
            autoClose: 1000,
          }
        );
      }
    } else {
      toast.error("Please fix validation errors.", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
      });
    }
  };

  const columns = [
    { field: "id", headerName: "No", flex: 1 },
    {
      field: "ClientName",
      headerName: "Client Name",
      flex: 1,
      // renderCell: (params) => params.row.ClientName?.DocLinkName || "-",
    },
    { field: "DocHeaderName", headerName: "Document Link URL", flex: 1 },
    { field: "DocHeaderValue", headerName: "	Document URL Key", flex: 1 },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => (
        <div className="flex space-x-2 justify-center">
          <button
            className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
            onClick={() => handleEdit(params.row)}
          >
            Update
          </button>
          <button
            className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
            onClick={() => handleDelete(params.row)}
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  const rows = (DocumentLinkDetails || [])?.map((el, index) => ({
    id: index + 1,
    MainId: el._id,
    // ClientName: {
    //   _id: el?.WhaDocLinkID?._id,
    //   DocLinkName: el?.WhaDocLinkID?.DocLinkName,
    // },
    ClientName: el?.WhaDocLinkID?.DocLinkName || "-", // <-- change here
    ClientNameId: el?.WhaDocLinkID?._id,
    DocHeaderName: el?.DocHeaderName,
    DocHeaderValue: el?.DocHeaderValue,
  }));

  if (
    !DocumentLinks ||
    !DocumentLinkDetails
  ) {
    return <Loader />;
  }

  return (
    <>
      <div className="">
        <div className="title">
          <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
            {editId ? "Update Document Link" : "Add  Document Link Details"}
            {/* Document Link Details */}
          </h3>
        </div>

        <div className="Form_bg_color bg-white shadow-sm rounded-xl mt-4">
          <form
            onSubmit={handleSubmit}
            className="grid grid-cols-12 gap-4 p-3 rounded-2xl"
          >
            {/* Document Link Name Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mb-1 block font-semibold">Document Link Name</h5>
              <select
                name="ClientName"
                value={formData.ClientName}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-[10px] border-2 border-black rounded"
              >
                <option value="">Select Client</option>
                {[...(DocumentLinks || [])]
                  .sort((a, b) => (a.DocLinkName || "").localeCompare(b.DocLinkName || ""))
                  .map((client) => (
                    <option key={client._id} value={client._id}>
                      {client.DocLinkName}
                    </option>
                  ))}
              </select>
              {errors.WhaDocLinkID && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.WhaDocLinkID}
                </p>
              )}
            </div>

            {/* Document Header Name Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mb-1 block font-semibold">Document Header Name</h5>
              <input
                type="text"
                name="DocHeaderName"
                // placeholder="Enter Your Range"
                value={formData.DocHeaderName}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.DocHeaderName && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.DocHeaderName}
                </p>
              )}
            </div>

            {/* DocHeaderValue Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mb-1 block font-semibold">
                Document Header Value
              </h5>
              <input
                type="text"
                name="DocHeaderValue"
                // placeholder="Enter Your Range"
                value={formData.DocHeaderValue}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.DocHeaderValue && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.DocHeaderValue}
                </p>
              )}
            </div>

            {/* Submit Button */}
            <div className="submit_Form col-span-12 flex justify-center">
              <button type="submit" className="All_button">
                {editId ? "Update" : "Submit"}
              </button>

              {editId && (
                <button
                  type="button"
                  className="bg-gray-500 text-white ms-2 px-4 py-2 rounded hover:bg-gray-600"
                  onClick={() => {
                    setFormData({
                      WhaDocLinkID: "",
                      DocHeaderName: "",
                      DocHeaderValue: "",
                    });
                    setEditId(null);
                    setErrors({});
                  }}
                >
                  Cancel
                </button>
              )}
            </div>
          </form>
        </div>

        <div className="px-2 py-6">
          <div className="title">
            <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block text-uppercase rounded">
              View Whatsapp API Setup
            </h3>
          </div>
          <div className="rounded-lg overflow-x-auto mt-3">
            <WpDynamicTable columns={columns} rows={rows} />
          </div>
        </div>
      </div>
    </>
  );
};

export default DocumentLinkDetail;
